import React from 'react';
import './ContactForm.css';

//const EMAIL_KEY = process.env.REACT_APP_EMAIL_KEY;

const ContactForm = () => {
  return (
    <>
      <form className="form-elements"  action="https://formspree.io/f/xayzlqzj"
  method="POST">
        <div className="element-holder">
          <label class="contact__form-label" for="name">
            Name
          </label>
          <input
            required
            placeholder="Enter Your Name"
            type="text"
            class="contact__form-input"
            name="username"
            id="name"
            autocomplete="off"
          />
        </div>
        <div className="element-holder">
          <label class="contact__form-label" for="email">
            Email
          </label>
          <input
            required
            placeholder="Enter Your Email"
            type="email"
            class="contact__form-input"
            name="email"
            id="email"
            autocomplete="off"
          />
        </div>
        <div className="element-holder">
          <label class="contact__form-label" for="message">
            Message
          </label>
          <textarea
            required
            cols="30"
            rows="7"
            class="text-aera"
            placeholder="Enter Your Message"
            name="message"
            id="message"></textarea>
        </div>
        <button type="submit" class="css-button-rounded--sky">
          Submit
        </button>
      </form>
    </>
  );
};

export default ContactForm;
